var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconRol = function SvgIconRol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M100 0H0v100h100V0ZM80 20.3H40v32.967H20v26.666h26.667V33.4h26.666v19.867h-20v26.666H80V20.3ZM26.667 59.933H40v13.334H26.667V59.933Zm33.333 0h13.333v13.334H60V59.933Z",
    fill: "#fff"
  })));
};

export { SvgIconRol as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGc+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMDAgMEgwVjEwMEgxMDBWMFpNODAgMjAuM0g0MFY1My4yNjY2SDIwVjc5LjkzMzRINDYuNjY2NlYzMy40SDczLjMzMzRWNTMuMjY2Nkg1My4zMzM0Vjc5LjkzMzRIODBWMjAuM1pNMjYuNjY2NiA1OS45MzM0SDQwVjczLjI2NjhIMjYuNjY2NlY1OS45MzM0Wk02MCA1OS45MzM0SDczLjMzMzRWNzMuMjY2OEg2MFY1OS45MzM0WiIgZmlsbD0id2hpdGUiLz4KICA8L2c+Cjwvc3ZnPgo=";